import Http from "./http";
import CONFIG from "../config";

const URL = CONFIG.API.WealthServices;

class WealthService extends Http {
    count;

    constructor() {
        super(URL);
    }

    prospect = (data) => {
        return this.postRequest(`/v1/create/prospect`, data, {});
    };
    prospectInformation = (key) => {
        return this.getRequest(`/v1/prospect/${key}/information`,
            {},
            {headers: {'Accept': '*/*'}});
    };
    getAgentSubjectByCustomerSubject = (key) => {
        return this.getRequest(`/v1/prospect/${key}`,
            {},
            {headers: {'Accept': '*/*'}});
    };
    offer = (key) => {
        return this.getRequest(`/v1/prospect/${key}/offer`,
            {},
            {headers: {'Accept': '*/*'}});
    };
    createActivaCookie = (key) => {
        return this.getRequest(`/v1/cookie/${key}/activa`);
    };
    createProduct = (key, source) => {
        return this.postRequest(`/v1/prospect/${key}/product`);
    };
    validateEmail = (data) => {
        return this.getRequest(
            `/v1/prospect/${data.subjectId}/validation/${data.email}`,
            {},
            {headers: {'Accept': '*/*'}}
        );
    };
    sendNotification = (key) => {
        return this.postRequest(`/v1/notification/${key}`);
    };
    validateNotification = (data) => {
        return this.getRequest(
            `/v1/notification/${data.key}?transaction_id=${data.transaction_id}&code=${data.code}`,
            {},
            {headers: {'Accept': '*/*'}}
        );
    };
    execute = (data, source) => {
        return this.postRequest(`/v1/bundle/execute`, data, {
            cancelToken: source.token,
        });
    };
    generateDocuments = (data, source) => {
        return this.postRequest(`/v1/documents/generate`, data, {
            cancelToken: source.token,
        });
    };
    planContracts = (data) => {
        return this.postRequest(`/v1/documents/data`, data, {});
    };
    consent = (data) => {
        return this.getRequest(`/v1/consents`, data)
    }
    consentSave = (data) => {
        return this.postRequest(`/v1/consent`, data, {})
    }
}

export default WealthService;
